import {mxgraph} from 'mxgraph';
import {Box, Vertex2d} from '../../../image-loader-v3/src/utils/Vertex';
import {ImageResizeInfo} from "../../../image-loader-v3/src/utils/utils";
import {LabelCtrlServ} from "../../../image-loader-v3/src/LabelCtrlServ";

type Label = {
    id?: string,
    code: string | number,
    text: string
}


export default class AdjustCell {

    imageResizeInfo?: ImageResizeInfo

    label: Label

    cell?: mxgraph.mxCell;

    constructor(private graph: mxgraph.mxGraph) {
        this.label = {code: '', text: ''};
    }

    get id() {
        return this.label.id
    }
    set id(str) {
        this.label.id = str
    }

    set bbox(box:Box) {
        this.drawVertex(box);
    }

    get bbox():Box {
        if (this.graph && this.cell) {
            const { x, y, width, height } = this.graph.view.getState(this.cell);
            return new Box(
                x, y, x + width, y + height
            );
        }
        return new Box(0,0,25,25);
    }

    drawVertex(box: Box) {
        if (!this.graph) {
            return;
        }
        const graph = this.graph;
        let parent = graph.getDefaultParent();
        graph.getModel().beginUpdate();
        if (this.cell) {
            let geo = this.graph.getCellGeometry(this.cell).clone();
            graph.getModel().setGeometry(this.cell, Object.assign(geo, {x: box.x1, y: box.y1}));
        } else {
            this.cell = graph.insertVertex(parent, null, '', box.x1, box.y1, box.width, box.height);
        }
        graph.getModel().endUpdate();
        graph.selectionModel.setCell(this.cell);
    }

    get isCellOnImage():Boolean {
        const {imageRect, containerRect} = this.getRects();
        const image = Box.fromDomRect(imageRect).toArray();

        const containerOffset = new Vertex2d(containerRect.x, containerRect.y);
        const cell = this.bbox.translate(containerOffset).toArray(); // cell 的 bbox距离页面顶部左边还有距离

        return cell[0] > image[0] && cell[1] > image[1]
            && cell[2] < image[2] && cell[3] < image[3]
    }

    get container() {
        return this.graph.container;
    }

    public getLabelCtrlServ():LabelCtrlServ {
        throw new TypeError('getLabelCtrlServ need to overwrite');
    }

    getRects():{imageRect: DOMRect, containerRect: DOMRect} {
        const labelService = this.getLabelCtrlServ();
        const imageRect = labelService.getImageElement().getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        return {imageRect, containerRect}
    }
    getOnImageBbox():Box{
        const labelService = this.getLabelCtrlServ();
        const {imageRect, containerRect} = this.getRects();
        const offset = new Vertex2d(containerRect.x - imageRect.x, containerRect.y - imageRect.y);
        return this.bbox.translate(offset).scale(1/labelService.userScale)
    }


    destroy() {
        if (this.cell && this.graph) {
            this.graph.removeCells([this.cell]);
        }
    }
}
